export default __webpack_public_path__ + "static/media/ai_web.3cd187ba6db0d14244bc7f10d96502f1.svg";